import { memo } from 'react';
import { Glossary, Common } from '@stockbit/ui';
import { useRouter } from 'next/router';
import { generateAlphabet } from 'utils/glossary';
import { IMenuByLatter } from '../types';
import { DATA_CY_GLOSSARY_LETTER_ITEM } from './__tests__/constant';

const { Menu } = Glossary;
const { Text } = Common;

function MenuByLetter({ selectedLetter }: IMenuByLatter): JSX.Element {
  const router = useRouter();
  const alphabetArr: string[] = generateAlphabet();

  const onClickLetterHandler = (letter: string): void => {
    const toLetter: string = letter === '#' ? '1' : letter;
    router.push('/glossary/letter/[letter]', `/glossary/letter/${toLetter}`);
  };

  return (
    <Menu
      defaultSelectedKeys={['a']}
      selectedKeys={[selectedLetter === '1' ? '#' : selectedLetter]}
      role="navigation"
    >
      {alphabetArr.map((letter) => (
        <Menu.Item
          data-cy={`${DATA_CY_GLOSSARY_LETTER_ITEM}-${letter}`}
          key={letter} onClick={() => onClickLetterHandler(letter)}>
          <Text padding="5px" color="inherit" align="center">
            {letter.toUpperCase()}
          </Text>
        </Menu.Item>
      ))}
    </Menu>
  );
}

export default memo(MenuByLetter);
